import { Badge } from './badge';
import { cn } from '@/lib/utils';

export function RatificationBadge({ ratification, className }: { ratification?: string | null; className?: string }) {
  if (!ratification) {
    return (
      <Badge variant="outline" className={cn('uppercase', className)}>
        Pending
      </Badge>
    );
  }
  let variant: 'default' | 'secondary' | 'outline' | 'destructive' = 'secondary';
  let label = '';
  switch (ratification.toUpperCase()) {
    case 'RATIFIED':
      variant = 'default'; // green
      label = 'Ratified';
      break;
    case 'OVERRULED':
      variant = 'secondary'; // red
      label = 'Overruled';
      break;
    default:
      label = ratification;
      variant = 'outline';
      break;
  }
  return (
    <Badge variant={variant} className={cn('uppercase', className)}>
      {label}
    </Badge>
  );
} 